import { useEffect } from 'react';
import { useAuthStore } from '../store/auth';

/**
 * AuthGate ist die EINZIGE Stelle, die checkAuth() aufruft.
 *
 * NIEMALS checkAuth() in LoginPage, RegistrationPage oder anderen
 * Kindkomponenten aufrufen! AuthGate setzt isLoading=true während der
 * Prüfung und unmountet dabei alle Children. Wenn ein Child dann beim
 * Remount erneut checkAuth() aufruft, entsteht eine Endlosschleife:
 *   AuthGate → isLoading=true → Spinner → Child unmount
 *   → isLoading=false → Child mount → checkAuth() → isLoading=true → ...
 *
 * Siehe: Bugfix Mai 2026, Commits d296eda + dbb2f1d
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const isLoading = useAuthStore((s) => s.isLoading);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
}
